import {BreakdownProposer} from './proposer.model';
import {Vehicle} from './vehicle.model';
import {Drivers} from './drivers.model';

export class Breakdown {
  id = '';
  broker_id = '';
  brokerCommission: number = null;
  brokerAdminFee: number = null;
  company_id = '';
  reference = '';
  status = '';
  declaration: boolean = null;
  inception_date = '';
  policy_holder_detail: any = new BreakdownProposer();
  ratingType = '';
  vehicles: any = [new Vehicle()];
  drivers: any = [new Drivers()];
  isReferred: boolean = null;
  policyId = '';
  effectiveDate = '';
  transactionalDate = '';
  oldPolicyId = '';
  discount = 0;
  type = 0;
  policyRefNumber: any;
  quoteMetaId: any;
  quote_meta_id: any;
  sequenceNumber: any;
  isSendEmail: any;
  data: { [key: string]: any};
  voluntaryExcess: any;
  commission: number;
  peliwica_fee: any;
  amlin_data: any;
  fleet_experiences: null;
  cover_to: any;
}
